import { DropdownOption } from '@ovpn-ui/core';

export const PromptTypes = {
    EditAwsContractMetadata: 'EDIT_AWS_CONTRACT_METADATA',
    AutocollectWarning: 'AUTOCOLLECT_WARNING',
    PayNow: 'PAY_NOW',
} as const;

export const ProductType = {
    Cloud: 'CVPN',
    As: 'AS',
} as const;
export type ProductType = typeof ProductType[keyof typeof ProductType];

export const SubscriptionType = {
    Premium: 'PREMIUM',
    Free: 'FREE',
} as const;
export type SubscriptionType = typeof SubscriptionType[keyof typeof SubscriptionType];

export const SubscriptionPlan = {
    Monthly: 'MONTHLY',
    Yearly: 'YEARLY',
} as const;
export type SubscriptionPlan = typeof SubscriptionPlan[keyof typeof SubscriptionPlan];

export const SubscriptionStatus = {
    NonRenewing: 'Non Renewing',
    PaymentDue: 'Payment Due',
    Cancelled: 'Cancelled',
    Trial: 'In Trial',
    Active: 'Active',
    Future: 'Future',
} as const;
export type SubscriptionStatus = typeof SubscriptionStatus[keyof typeof SubscriptionStatus];

export const EnforcementType = {
    Seats: 'SEATS',
    Connections: 'CONNECTIONS',
} as const;
export type EnforcementType = typeof EnforcementType[keyof typeof EnforcementType];

export const PaymentMethodKey = {
    noAutoCharge: 'noAutoCharge',
    myPrimary: 'myPrimary',
} as const;
export type PaymentMethodKey = typeof PaymentMethodKey[keyof typeof PaymentMethodKey];

export const UserAuthorityTypes = {
    EnrolledOwner: 'ENROLLED_OWNER',
    Owner: 'OWNER',

    BillingAdmin: 'G_BILLING_ADMIN',

    CloudAdmin: 'PRODUCT_ADMIN',
    Member: 'MEMBER',
} as const;
export type UserAuthorityTypes = typeof UserAuthorityTypes[keyof typeof UserAuthorityTypes];

export const PaymentMethodType = {
    PayPal: 'PAYPAL_EXPRESS_CHECKOUT',
    AmazonPay: 'AMAZON_PAYMENTS',
    ACH: 'DIRECT_DEBIT',
    CreditCard: 'CARD',
} as const;
export type PaymentMethodType = typeof PaymentMethodType[keyof typeof PaymentMethodType];

export const PaymentMethodRole = {
    Primary: 'PRIMARY',
    Backup: 'BACKUP',
    None: 'NONE',
} as const;
export type PaymentMethodRole = typeof PaymentMethodRole[keyof typeof PaymentMethodRole];

export const ChargebeeEvents = {
    PayNow: 'pay-now',
} as const;

export const Currency = {
    USD: 'USD',
    EUR: 'EUR',
} as const;
export type Currency = typeof Currency[keyof typeof Currency];

export const CurrencySymbol: Record<Currency, string> = {
    EUR: '€',
    USD: '$',
};

export const currencyOptions: DropdownOption[] = [
    { id: 'USD', title: 'USD' },
    { id: 'EUR', title: 'EUR' },
];
